export const formatSortCode = (raw) => {
  if (typeof raw !== "string") return null;

  return raw.match(/.{1,2}/g).join("-");
};
